import(/* webpackMode: "eager" */ "/home/crazysal/sit-a/bd-mobile-next/app/(main)/hottest-deals/page.tsx");
